import { jsx as p } from "react/jsx-runtime";
import { offerDefaultErrors as d } from "../../pages/checkout/constants/default-errors.mjs";
import { buyOffer as w } from "../../pages/checkout/api/index.mjs";
import { BadRequest as y, createHttpClient as g } from "@systemeio/util";
import { useStore as b } from "../../store/index.mjs";
import { twJoin as h } from "tailwind-merge";
import R from "../../ui-kit/theme-button.mjs";
const B = g();
async function x(e) {
  const t = await B.get(e, {
    maxRedirects: 0
    // Prevent axios from automatically following redirects
  });
  if (t.status === 200) {
    window.location.assign(t.data.options.paypalLink);
    return;
  }
  if (t.status >= 300 && t.status < 400) {
    const r = t.headers.location;
    if (r) {
      window.location.assign(r);
      return;
    }
  }
  throw new Error("No redirect URL found");
}
function P({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: r,
  setErrors: a,
  setIsFetching: n,
  preSubmit: i,
  handleBadRequest: s,
  hasErrors: c
}) {
  const { locale: f } = b(), u = async (l) => {
    l.preventDefault();
    try {
      n(!0), a(d);
      const o = i();
      if (!o) return;
      const { redirect: m } = await w(o, f);
      await x(m);
    } catch (o) {
      if (o instanceof y)
        s(o);
      else
        throw o;
    } finally {
      n(!1);
    }
  };
  return /* @__PURE__ */ p(
    R,
    {
      disabled: r,
      className: h("main-transition-colors", c && "bg-danger focus:bg-danger"),
      onClick: u,
      isFetching: e,
      type: "submit",
      children: t
    }
  );
}
export {
  P as PaypalRestPaymentButton,
  x as goToRedirect
};
